import { Injectable } from '@angular/core';
import type { CardDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-descriptor.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { RoomFindInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-find.dto';
import type { RoomPersonalAccountQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/room/room-personal-account-query.dto';
import type { TransitTaskPageInterface } from '@zaoblako/shared/modules/cctv/dtos/transit-task/transit-task-page.dto';
import type { TransitTaskQueryInterface } from '@zaoblako/shared/modules/cctv/dtos/transit-task/transit-task-query.dto';
import type { CommentaryFileFindInterface } from '@zaoblako/shared/modules/storage/dtos/commentary-file/commentary-file-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PersonalAccountTransitTaskService extends BaseService {
  protected baseUrl = '/personal-account/cctv/transit-task';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public getCardDescriptor(taskId?: number): Observable<CardDescriptorInterface> {
    return this.http.get<CardDescriptorInterface>(`${this.baseUrl}/card-descriptor`, {
      params: taskId ? { taskId } : {}
    });
  }

  public findPage(queryParams: TransitTaskQueryInterface): Observable<TransitTaskPageInterface> {
    return this.http.get<TransitTaskPageInterface>(`${this.baseUrl}/items`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getFiles(taskId: number): Observable<CommentaryFileFindInterface[]> {
    return this.http.get<CommentaryFileFindInterface[]>(`${this.baseUrl}/${taskId}/files`);
  }

  public getAvailableRooms(query?: RoomPersonalAccountQueryInterface): Observable<RoomFindInterface[]> {
    return this.http.get<RoomFindInterface[]>('/personal-account/cctv/rooms', {
      params: this.objectToHttpParams(query)
    });
  }
}
